import { render, staticRenderFns } from "./PromotionCategoryLookup.vue?vue&type=template&id=aa6d08ce&lang=pug"
import script from "./PromotionCategoryLookup.vue?vue&type=script&lang=js"
export * from "./PromotionCategoryLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports